import { Component, OnInit, ElementRef, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { BackstrapService } from '../backstrap.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-public-report',
  templateUrl: './public-report.component.html',
  styleUrls: ['./public-report.component.css']
})
export class PublicReportComponent implements OnInit {
  crashUid: string;
	isLoading: boolean;
	reportData: any;
  vehicleData: any;
	lastUpdate: any;
  formGroups: any[];
  reportPhotos: any;
  embedLink: any;
  selectedPhoto: any;
  currentUser: any;
  noAccess: boolean;
  serviceLocationId: number;

  @ViewChild('commonBoxWindow') commonBoxWindow: ElementRef;


  constructor(private route: ActivatedRoute, private api: BackstrapService, 
              private router: Router, private sanitizer: DomSanitizer) { 
    this.crashUid = null;
    this.isLoading = true;
  }

  ngOnInit(){
    this.crashUid = this.route.snapshot.paramMap.get('reportUid');
  	if(this.crashUid !== null && typeof(this.crashUid) !== 'undefined') {
  		// GET THE REPORT FROM THE DB
  		this.api.getPublicReport(this.crashUid)
  		.subscribe((data) => {
  		  if(data != null) {
          this.reportData = {};

          let d;
          if(data['fnol_incident_datetime'] != null && data['fnol_incident_datetime'] !== '') {
            d = new Date(data['fnol_incident_datetime']);
          }

          this.serviceLocationId = data['service_location_id'];

          
          // GENERAL INFO
          this.reportData['crash_date'] = {
            fieldName: 'crash_date',
            value: d != null ? [[this.getDate(d)]] : [['']],
            label: 'Date of Accident',
            type: 'text',

          };
          this.reportData['crash_time'] = {
            fieldName: 'crash_time',
            value: d != null ? [[this.getTime(d)]] : [['']],
            label: 'Time of Call',
            type: 'text'
          };
          this.reportData['location'] = {
            fieldName: 'location',
            value: data['fnol_incident_location'] !== '' ? [[data['fnol_incident_location']]] : [['']],
            label: 'Reported Location',
            type: 'text'
          };

          switch(this.serviceLocationId) {
            case 1:
            case 3:
              this.reportData['nopd_item_number'] = {
                fieldName: 'item_number',
                value: data['item_number'] !== '' ? [[data['item_number']]] : [['']],
                label: 'NOPD Item Number',
                type: 'text'
              };
              break;
            case 2:
              this.reportData['bpd_item_number'] = {
                fieldName: 'item_number',
                value: data['item_number'] !== '' ? [[data['item_number']]] : [['']],
                label: 'BPD Item Number',
                type: 'text'
              };
              break;
            case 4:
              this.reportData['sgpd_item_number'] = {
                fieldName: 'item_number',
                value: data['item_number'] !== '' ? [[data['item_number']]] : [['']],
                label: 'SGPD Item Number',
                type: 'text'
              };
              break;
            default:
              this.reportData['nopd_item_number'] = {
                fieldName: 'item_number',
                value: data['item_number'] !== '' ? [[data['item_number']]] : [['']],
                label: 'NOPD Item Number',
                type: 'text'
              };
          }
          
          // this.reportData['crash_id'] = {
          //   fieldName: 'crash_id',
          //   value: data['crash_id'] !== '' ? [[data['crash_id']]] : [['']],
          //   label: 'OSS Crash ID',
          //   type: 'text'
          // }

          this.vehicleData = [];
          for(let v of data['vehicles']) {
            let printVeh = [
              {
                fieldName: 'dr_lic_num',
                value: v.drivers_license_number !== '' ? [v.drivers_license_number] : [['']],
                label: 'License',
                type: 'text'
              },
             {
                fieldName: 'driver_address',
                value: [this.getAddress(v.driver_address_line_1, v.driver_address_line_2, v.driver_city, v.driver_state, v.driver_zip, v.driver_country)],
                label: 'Driver\'s Address',
                type: 'text'
              },
              // {
              //   fieldNmae: 'driver_phone',
              //   value: v.driver_phone_number != null ? [v.driver_phone_number] : [''],
              //   label: 'Driver\'s Phone',
              //   type: 'text'
              // },
              {
                fieldNmae: 'owner_name',
                value: [`${v.vehicle_owner_first_name} ${v.vehicle_owner_middle_name} ${v.vehicle_owner_last_name}`] || [['']],
                label: 'Owner\'s Name',
                type: 'text'
              },
              {
                fieldName: 'owner_address',
                value: [this.getAddress(v.vehicle_owner_address_line_1, v.vehicle_owner_address_line_2, v.vehicle_owner_city, v.vehicle_owner_state, v.vehicle_owner_zip, v.vehicle_owner_country)],
                label: 'Owner\'s Address',
                type: 'text'
              },
              {
                fieldNmae: 'insurance_company',
                value: v.insurance_company_name ? [v.insurance_company_name] : [''],
                label: 'Agency',
                type: 'text'
              },
              {
                fieldNmae: 'insurance_policy',
                value: v.insurance_policy_number ? [v.insurance_policy_number] : [''],
                label: 'Policy Number',
                type: 'text'
              },
              {
                fieldNmae: 'vehicle_year',
                value: v.vehicle_year ? [v.vehicle_year] : [''],
                label: 'Vehicle Year',
                type: 'text'
              },
              {
                fieldNmae: 'vehicle_make',
                value: v.vehicle_make ? [v.vehicle_make] : [''],
                label: 'Vehicle Make',
                type: 'text'
              },
              {
                fieldNmae: 'vehicle_model',
                value: v.vehicle_model ? [v.vehicle_model] : [''],
                label: 'Vehicle Model',
                type: 'text'
              },
            ]
            this.vehicleData.push(printVeh);
          }

          //reformat vehicles to make the template not a nightmare
          var vehicles = [];
          var subarrays = -1;
          for(var v = 0; v < this.vehicleData.length; v++){
            if((v + 1) % 2 === 1){
              subarrays++;
              if(vehicles[subarrays] === undefined) vehicles[subarrays] = [];
            }
            vehicles[subarrays].push(this.vehicleData[v]);
          }
          this.vehicleData = vehicles;

          this.isLoading = false;
  		  }
  		  else {
  		    alert('This report does not exist or is no longer available.');
  		  }
  		},
  		(err) => {
        if(err.error.err_code == 'c0004') {
          alert('This report does not exist or is no longer available.');
        }
  		  console.log(err);
  		});
	  }
  }

  formatOptions(o) {
    o.value = [[o.value]];
    return o;
  }

  getAddress(l1, l2, city, state, zip, country) {
    let address = '';
    if (l1) {
      address += l1;
    }
    if (l2) {
      address += `\n${l2}`;
    }
    if (city || state || zip) {
      address += `\n${city || ''}${city && (state || zip) ? ', ' : ''}${state || ''}${state && zip ? ' ' : ''}${zip || ''}`;
    }
    if (country) {
      address += `\n${country}`;
    }
    return address;
  }

  getDate(dt) {
    const day = dt.getDate();
    const month = dt.getMonth() + 1; // Months are zero-based in JavaScript
    const year = dt.getFullYear();
    return `${month < 10 ? '0'+month : month}/${day < 10 ? '0'+day : day}/${year}`;
  }

  getTime(dt) {
    const hours = dt.getHours();
    const minutes = dt.getMinutes();
    return `${hours < 10 ? '0'+hours : hours}:${minutes < 10 ? '0'+minutes : minutes}`;
  }

}
